export default __webpack_public_path__ + "static/media/helper-key.f053fde2.png";